import { Button, Icon, message, Modal, Upload } from "antd";
import React, { useCallback } from "react";
import { RcFile } from "antd/lib/upload/interface";
import {
    checkCourseWareStr,
    errorMessage,
    uploadToQiNiu
} from "service/service";
import {
    removePaperEvaluationFileUrl,
    savePaperEvaluationFileUrl
} from "service/exam";
import styles from "./index.module.scss";

interface UploadFileProps {
    evaluationId: string;
    fileUrl: string;
    onChange: () => void;
}

export default function UploadFile({
    evaluationId,
    fileUrl,
    onChange
}: UploadFileProps) {
    const beforeUpload = async (file: RcFile) => {
        if (checkCourseWareStr(file).next) {
            await uploadToQiNiu(file)
                .then(data =>
                    savePaperEvaluationFileUrl(evaluationId, data.url)
                )
                .then(onChange)
                .catch(e => message.error(errorMessage(e)));
        } else {
            message.error(checkCourseWareStr(file).msg);
            return Promise.reject(file);
        }
    };

    const onRemoveFile = useCallback(
        (e: React.MouseEvent) => {
            e.preventDefault();

            Modal.confirm({
                content: "确定要删除吗?",
                onOk: async () => {
                    try {
                        await removePaperEvaluationFileUrl(evaluationId);
                        onChange();
                    } catch (e) {
                        message.error(errorMessage(e));
                    }
                }
            });
        },
        [evaluationId, onChange]
    );

    return (
        <>
            <Upload
                showUploadList={false}
                accept=".docx"
                beforeUpload={beforeUpload}>
                <Button>
                    <Icon type="upload" />
                    上传
                </Button>
            </Upload>

            {fileUrl && (
                <a
                    title="下载试卷检查报告"
                    href={fileUrl}
                    target="_blank"
                    rel="noreferrer"
                    className={styles.link}>
                    <Icon type="link" /> 试卷检查报告{" "}
                    <Icon
                        type="delete"
                        title="删除"
                        className={styles.remove}
                        onClick={onRemoveFile}
                    />
                </a>
            )}
        </>
    );
}
